export const TRACKING_NUMBER = 'tn';
export const ESO_ID = 'esoid';
export const REQUEST_TYPE = 'REQUEST_TYPE';
export const ESO_FID = 'esoFiId';
export const USER = 'User';
export const DEPARTMENT = 'Department';
export const HOSPITAL = 'Hospital';
export const EMAIL = 'Email';
export const Familiar_ESO_ID = 'Familiar_ESO_ID';
export const Network_ID = 'Network_ID';
export const DESCRIPTION = 'Description';
export const ACCOUNT_TYPE = 'Account_Type';
export const USER_TYPE = 'User_Type';
export const USER_ACCOUNT_TYPE = 'User_Account_Type';
